<div class="desktop">
  <div class="row align-items-center">
    <div class="col-1 pr-32px">
      <img src="../../../assets/icons/DESKTOP/ic_toc_24px.png" alt="">
    </div>
    <div class="col">
      <span class="f-18 f-bold">
        {{i18n.SIGNATURE.EVENTOS_DO_DOCUMENTO}}
      </span>
    </div>
  </div>
  <div class="row pt-20px">
    <div class="col">
      <div class="history-list pl-48px">
        <div class="history-item" *ngFor="let signerItem of signerHistory">
          <div class="row">
            <div class="col">
              <span class="f-12">{{signerItem.date}}, {{signerItem.hour}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="f-12">
                {{signerItem.signer?.name}}
                {{i18n.SIGNATURE.ASSINOU_COMO}} {{signerItem.signer?.type}}:
                 {{signerItem.signer?.email}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span></span>
            </div>
          </div>                
        </div>
      </div>
    </div>
  </div>
</div>

<div class="mobile">
  <div class="row pt-16px">
    <div class="col-1 pr-32px">
      <img src="../../../assets/icons/DESKTOP/ic_toc_24px.png" class="mobile-icon" alt="">
    </div>
    <div class="col">
      <span class="f-14">
        {{i18n.SIGNATURE.EVENTOS_DO_DOCUMENTO}}
        &nbsp;<img (click)="showMore = !showMore" src="../../../assets/icons/MOBILE/ic_arrow_drop_down_circle_24px.png" [ngClass]="{'upsidedown': showMore}" class="mobile-btn-icon" alt="">
      </span>
    </div>
  </div>
  <div class="row pt-20px" *ngIf="showMore">
    <div class="col">
      <div class="history-list">
        <div class="history-item f-10" *ngFor="let signerItem of signerHistory">
          <div class="row">
            <div class="col">
              <span>{{signerItem.date}}, {{signerItem.hour}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span>{{signerItem.signer?.name}} {{i18n.SIGNATURE.ASSINOU_COMO}} {{signerItem.signer?.type}}: {{signerItem.signer?.email}}</span>
            </div>
          </div>            
        </div>
      </div>
    </div>
  </div>
</div>